import { render, staticRenderFns } from "./doenca.vue?vue&type=template&id=ae7df044"
import script from "./doenca.vue?vue&type=script&lang=js"
export * from "./doenca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports